module.exports = __webpack_public_path__ + "img/icon-gear.2c4a3770.svg";